import { SingleSelect, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";
import { items as originalItems } from "designSystemLegacy/data";
import { cloneDeep } from "lodash";

export default () => {
	const items = cloneDeep(originalItems);

	items[1].disabled = true;
	items[3].disabled = true;
	items[5].disabled = true;

	return (
		<CssColumnGrid columns={2}>
			<Text semiBold text="Normal" />
			<Text semiBold text="Grouped" />
			<SingleSelect
				options={items}
				value={items[0]}
			/>
			<SingleSelect
				grouped
				options={items}
				value={items[0]}
			/>
		</CssColumnGrid>
	);
};